import { Status, UpdateStatus, CheckDevice } from "./Config/Status.js";
import CustomProperty from "./Modules/CustomProperty.js";
import Animation from "./Modules/Animation.js";
// import DrawerMenu from "./Modules/DrawerMenu.js";
// import Modal from "./Modules/Modal.js";
// import ScrollTop from "./Modules/ScrollTop.js";
import * as Slider from "./Modules/Slider.js";
import Navigation from "./Modules/Navigation.js";



import Home from "./Page/Home/App.js";

const page = Status.page.toLowerCase();

// init
CheckDevice();
CustomProperty();
Slider.MarqueeSlider();
Slider.CarouselSlider();
Navigation();
if(Status.isLocal) {
  // Debug();
}


// preload
window.addEventListener("DOMContentLoaded", () => UpdateStatus.load());


// load
window.addEventListener("load", () => UpdateStatus.load());
window.addEventListener("load", () => Animation.update());

// resize 
window.addEventListener("resize", () => UpdateStatus.resize());
window.addEventListener("resize", () => CheckDevice());
window.addEventListener("resize", () => CustomProperty());

// scroll 
window.addEventListener("scroll", () => UpdateStatus.scroll());
window.addEventListener("scroll", () => Animation.update());

// orientationchange
window.addEventListener("orientationchange", () => UpdateStatus.resize());

switch(page) {
  case 'home':
    Home.init();
    break;
}